import { authClient, API } from "../index";

// Expectativas (pregunta de inicio de la jornada) de una sesión: [{ _id, text, createdAt }]
export const getExpectationsBySession = sessionId => {
	return authClient().get(`${API}/expectation/session/${sessionId}`);
};

// Eliminar una expectativa
export const deleteExpectation = id => {
	return authClient().delete(`${API}/expectation/${id}`);
};
